import { useCallback } from 'react';
import { FormikProps } from 'formik';

import { currentFileUploadSelector } from '@Store/selectors/fileUploadSelector';
import { useAppSelector } from '@Hooks/index';
import { getDocumentTypesDict } from '@Store/selectors/dictionarySelector';
import { transformDictToOptions } from '@Utils/transformToOptions';

import { RcCustomRequestOptions } from '@Components/types/UploadType';
import { Attachment } from '@Components/types/Attachment';
import { currentMaterialRequest } from '@Features/MaterialRequest/requests/MaterialRequisition/store/selectors/materialRequestSelector';
import { FileUpload } from '@Types/index';

import { MaterialRequisitionDocumentRequest } from '@Types/api/form';
import ModalContent from './components/ModalContent';

interface DocumentModalContentProps {
  uploadedFile?: Attachment;
  isEditMode: boolean;
  isDisableSaveButton: boolean;
  formik: FormikProps<MaterialRequisitionDocumentRequest>;
  onUploadedFileRemove?: (value: boolean | undefined) => void;
  onSave: (
    formikValues: MaterialRequisitionDocumentRequest,
    requisitionId: number,
    fileUpload: FileUpload,
    addAnotherItem?: boolean
  ) => Promise<void>;
  onFileRequest: (options: RcCustomRequestOptions) => void;
  onFileRemove: () => void;
  onDisableSaveButton: (isDisable: boolean) => void;
}

const DocumentModalContent: React.FC<DocumentModalContentProps> = ({
  onSave,
  onFileRemove,
  onFileRequest,
  onDisableSaveButton,
  uploadedFile,
  onUploadedFileRemove,
  isEditMode,
  isDisableSaveButton,
  formik,
}) => {
  const documentTypes = useAppSelector(getDocumentTypesDict);
  const currentMRequest = useAppSelector(currentMaterialRequest);
  const currentFileUpload = useAppSelector(currentFileUploadSelector);

  const handleSaveDocument = useCallback(() => {
    onSave(formik.values, currentMRequest?.requestId, currentFileUpload, true);
    formik.resetForm();
  }, [
    formik.values,
    currentMRequest?.requestId,
    currentFileUpload?.filepath,
    onSave,
  ]);

  return (
    <ModalContent
      formik={formik}
      onDisableSaveButton={onDisableSaveButton}
      isDisableSaveButton={isDisableSaveButton}
      handleSubmit={formik.handleSubmit}
      handleSaveDocument={handleSaveDocument}
      filePath={currentFileUpload.filepath}
      onFileRemove={onFileRemove}
      onFileRequest={onFileRequest}
      onUploadedFileRemove={onUploadedFileRemove}
      uploadedFile={uploadedFile}
      documentTypes={transformDictToOptions(documentTypes)}
      isEditMode={isEditMode}
    />
  );
};

export default DocumentModalContent;
